import { createFeature, createReducer, on } from '@ngrx/store';
import { ServedByOption, ServedByOptionType } from '../../entities/served-by-option.entity';
import { sepaActions, sepaApiActions } from './sepa.actions';

export interface SepaState {
  loading: boolean;
  hasSepa: boolean | null;
  errorMessage: string;
  options: ServedByOption[];
  selectedOption: ServedByOption;
  displaySuccessHint: boolean;
}

export const initialSepaState: SepaState = {
  loading: false,
  hasSepa: null,
  errorMessage: '',
  options: [],
  selectedOption: undefined,
  displaySuccessHint: false,
};

export const sepaFeature = createFeature({
  name: 'sepa',
  reducer: createReducer(
    initialSepaState,
    on(sepaActions.loadHasSepa, (state): SepaState => ({ ...state, loading: true, errorMessage: '' })),
    on(sepaApiActions.loadHasSepaSuccess, (state, { hasSepa }): SepaState => ({ ...state, hasSepa, loading: false })),
    on(sepaApiActions.loadHasSepaFailure, (state): SepaState => ({ ...state, loading: false })),
    on(sepaActions.toggleSepa, (state): SepaState => ({ ...state, displaySuccessHint: false, errorMessage: '' })),
    on(
      sepaApiActions.toggleSepaSuccess,
      (state, { response }): SepaState => ({
        ...state,
        hasSepa: response.useDirectDebit,
        errorMessage: response.msg,
      }),
    ),
    on(sepaActions.loadOptions, (state): SepaState => {
      const options = [
        { label: 'savings-plan.savings-plan-form.account', value: ServedByOptionType.Account, selected: !state.hasSepa },
        { label: 'savings-plan.savings-plan-form.sepa', value: ServedByOptionType.Sepa, selected: state.hasSepa },
      ];
      return {
        ...state,
        options,
        selectedOption: options.find((option) => option.selected),
      };
    }),
    on(sepaActions.changeOption, (state, { optionType }): SepaState => {
      const options = state.options.map((option) => ({
        ...option,
        selected: option.value === optionType,
      }));
      return {
        ...state,
        options,
        selectedOption: options.find((option) => option.selected),
      };
    }),
    on(sepaActions.displaySuccessHint, (state): SepaState => ({ ...state, displaySuccessHint: true })),
  ),
});
